import * as Yup from "yup";

export default Yup.object().shape({
  title: Yup.string().required("Field required"),
  items: Yup.array().min(1).required("Require items"),
});
